import moment from 'moment'

const getWeekName = n => {
    let week = ''
    switch (n) {
        case 0:
            week = ' 周日'
            break
        case 1:
            week = ' 周一'
            break
        case 2:
            week = ' 周二'
            break
        case 3:
            week = ' 周三'
            break
        case 4:
            week = ' 周四'
            break
        case 5:
            week = ' 周五'
            break
        case 6:
            week = ' 周六'
            break
    }
    return week
}

// 日期转换成 xxxx年xx月xx日 周x
const dateToStr = classDate => {
    if (!classDate) {
        return ''
    }
    let note = ''
    if (moment(classDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
        note = ' 今天'
    } else if (classDate == moment().add(1, 'days').format('YYYY-MM-DD')) {
        note = ' 明天'
    } else if (classDate == moment().add(2, 'days').format('YYYY-MM-DD')) {
        note = ' 后天'
    } else {
        let n = moment(classDate).day()
        note = getWeekName(n)
    }
    return moment(classDate).format('MM月DD日') + note
}

// 数字转 x天x时x分
const timeToStr = value => {
        if (!value || isNaN(parseInt(value))) return ''
        value = parseInt(value)
        let str = '约'
        let day = 0
        let hours = 0;
        if (value >= 1440) {
            day = Math.floor(value / 1440)
            value = value % 1440
        }
        if (value >= 60) {
            hours = Math.floor(value / 60)
            value = value % 60
        }
        if (day > 0) {
            str += day + '天' + hours + '时' + value + '分'
        } else if (hours > 0) {
            str += hours + '时' + value + '分'
        } else {
            str += value + '分'
        }
        return str
    }
    // 日期转换成 xx月xx日 周x
const dateToNewStr = classDate => {
        if (!classDate) {
            return ''
        }
        let note = ''
        if (moment(classDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
            note = ' (今天)'
        } else if (classDate == moment().add(1, 'days').format('YYYY-MM-DD')) {
            note = ' (明天)'
        } else if (classDate == moment().add(2, 'days').format('YYYY-MM-DD')) {
            note = ' (后天)'
        }
        let week = ''
        let n = moment(classDate).day()
        week = getWeekName(n)
        return moment(classDate).format('MM月DD日') + note + week
    }
    // 金钱格式转换
const toThousands = Money => {
    Money = parseFloat(Money)
    if (isNaN(Money) || !Money) {
        return 0
    }
    Money = Money.toFixed(2)
    let num = (Money.split('.')[0] || 0).toString()
    let result = ''
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result
        num = num.slice(0, num.length - 3)
    }
    if (num) { result = num + result }
    result = result + '.' + Money.split('.')[1]
    return result
}

const dateTimeSubStr = str => {
    if (!str) {
        return "";
    }
    return str.substring(0, 16);
}
const dateSubStr = str => {
    if (!str) {
        return "";
    }
    return str.substring(0, 10);
}
const timeSubStr = str => {
    if (!str) {
        return "";
    }
    return str.substring(0, 5);
}

export default {
    dateToStr,
    timeToStr,
    dateToNewStr,
    toThousands,
    dateTimeSubStr,
    dateSubStr,
    timeSubStr
}